import React from 'react';

export function VideoSection() {
  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8">
          Watch the 60 Second Breakdown
        </h2>

        <div className="relative w-full max-w-3xl mx-auto">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              title="Priority AI Services - 60 second breakdown"
              src="https://www.loom.com/embed/78ba466842834981aee6554fd57baed4"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-2xl"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
